import conn from "@/store/utils/connection";
import rekeningBankAPI from "@/store/utils/api-route/rekeningBankAPI";
import resulter from "@/store/utils/resulter";
import state from "./state"
import transaksiAPI from "@/store/utils/api-route/transaksiAPI";

const actions = {
	async fetchRekeningAtasNama({commit}) {
		try {
			const res = await conn.get(rekeningBankAPI.rekeningBank.atasNama)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setRekeningAtasNama", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},


	queryFilterListRekeningBank({commit, rootGetters}) {
		let getFilter = rootGetters["filterGlobalModule/getFilter"]
		let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"]

		let query = {
			sort: getFilter.orderBy,
			limit: state.pagination.limit,
			offset: state.pagination.offset
		}

		// jenis transaksi
		if (getFilterItem.rekeningAtasNama.length > 0) {
			query.atas_nama = getFilterItem.rekeningAtasNama
		}
		// search
		if (state.isSearch) {
			query.key = state.search.key
		}

		return query
	},
	queryFilterRiwayatTransfer({commit, rootGetters}, idakun) {
		let getFilter = rootGetters["filterGlobalModule/getFilter"]
		let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"]

		let query = {
			idakun_keuangan: idakun,
			limit: state.paginationRiwayatTransfer.limit.toString(),
			offset: state.paginationRiwayatTransfer.offset.toString(),
		}

		// periode
		query.filter_tanggal = getFilterItem.periode.startDate !== "" && getFilterItem.periode.endDate !== "" ? 1 : 0
		getFilterItem.periode.startDate !== "" ? query.tanggal_awal = getFilterItem.periode.startDate : ""
		getFilterItem.periode.endDate !== "" ? query.tanggal_akhir = getFilterItem.periode.endDate : ""

		// in
		query.pembayaran_transaksi = getFilterItem.uangMasukRiwayatTransfer.filter(v => v === "pembayaran_transaksi").length > 0 ? 1 : 0
		query.transfer_masuk = getFilterItem.uangMasukRiwayatTransfer.filter(v => v === "transfer_masuk").length > 0 ? 1 : 0
		query.settlement_edc = getFilterItem.uangMasukRiwayatTransfer.filter(v => v === "settlement_edc").length > 0 ? 1 : 0
		query.entry_manual_masuk = getFilterItem.uangMasukRiwayatTransfer.filter(v => v === "entry_manual_masuk").length > 0 ? 1 : 0

		//out
		query.refund_transaksi = getFilterItem.uangKeluarRiwayatTransfer.filter(v => v === "refund_transaksi").length > 0 ? 1 : 0
		query.transfer_keluar = getFilterItem.uangKeluarRiwayatTransfer.filter(v => v === "transfer_keluar").length > 0 ? 1 : 0
		query.pengeluaran_biaya = getFilterItem.uangKeluarRiwayatTransfer.filter(v => v === "pengeluaran_biaya").length > 0 ? 1 : 0
		query.entry_manual_keluar = getFilterItem.uangKeluarRiwayatTransfer.filter(v => v === "entry_manual_keluar").length > 0 ? 1 : 0

		return query
	},

	async fetchRekeningBankGetIdAkun({commit, dispatch}) {
		try {
			const res = await conn.get(rekeningBankAPI.rekeningBank.getIdAkun)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult("", res.data.data)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchRekeningBankList({commit, dispatch}) {
		try {
			let query = await dispatch("queryFilterListRekeningBank")
			const res = await conn.get(rekeningBankAPI.rekeningBank.list, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				await conn.setQueryString(query)
				commit("setRekeningBank", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchRekeningBankDetail({commit}, id) {
		try {
			let query = {
				idrekening: id
			}
			const res = await conn.get(rekeningBankAPI.rekeningBank.detail, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setRekeningBankDetail", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchRekeningBankCreate({commit}, form) {
		try {
			const res = await conn.post(rekeningBankAPI.rekeningBank.create, form, conn.contentType.form)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchRekeningBankUpdate({commit}, payload) {
		try {
			let query = {jenis: payload.jenis}
			const res = await conn.post(rekeningBankAPI.rekeningBank.update, payload.form, conn.contentType.form, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchRekeningBankDelete({commit}, idakun) {
		try {
			let query = {id_akun_keuangan: idakun}
			const res = await conn.post(rekeningBankAPI.rekeningBank.delete, null, conn.contentType.form, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchAkunKeuangan({commit}) {
		try {
			const res = await conn.get(rekeningBankAPI.transferKas.akunKeuangan)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setAkunKeuangan", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async createTransferKas({commit}, form) {
		try {
			const res = await conn.post(rekeningBankAPI.transferKas.create, form, conn.contentType.multipart)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async fetchRiwayatTransferList({commit, dispatch}, idakun) {
		try {
			let query = await dispatch("queryFilterRiwayatTransfer", idakun)
			const res = await conn.get(rekeningBankAPI.riwayatTransfer.list, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				await conn.setQueryString(query)
				commit("setRiwayatTransfer", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchRiwayatTransferDetail({commit, dispatch}, payload) {
		try {
			let query = {
				ref_id: payload.ref_id,
				ref_type: payload.ref_type,
			}
			const res = await conn.get(rekeningBankAPI.riwayatTransfer.detail, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				await conn.setQueryString(query)
				commit("setRiwayatTransferDetail", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async export({commit, dispatch}, idakun) {
		try {
			let query = await dispatch("queryFilterRiwayatTransfer", idakun)
			let formData = new FormData
			formData.append("type", "riwayat_transfer_rekening_bank")
			formData.append("filter_json", JSON.stringify(query))

			const res = await conn.post(transaksiAPI.export.job, formData, conn.contentType.form)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				localStorage.setItem("key_export_riwayat_transfer", "export:job:keuangan:riwayatbank")
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportTrack({commit}) {
		try {
			let keyExport = localStorage.getItem("key_export_riwayat_transfer")
			if (keyExport === null) {
				return resulter.errorResult()
			}
			let query = {
				key: keyExport,
			}
			const res = await conn.get(transaksiAPI.export.track, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportDeleteCluster({commit}, key) {
		try {
			let query = {
				key: key
			}
			const res = await conn.get(transaksiAPI.export.delete.cluster, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportDeleteMaster({commit}) {
		try {
			let keyExport = localStorage.getItem("key_export_riwayat_transfer")
			let query = {
				key: keyExport
			}
			const res = await conn.get(transaksiAPI.export.delete.master, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				localStorage.removeItem("key_export_riwayat_transfer")
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	}
}

export default actions